declare namespace $ {

	type __shm_hitalama_map_widget_tools_1 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_widget_tools['settings_widget_enabled'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_widget_tools['widget'] >['settings_widget_enabled'] >[0]
	>
	type $mol_button_copy__title_shm_hitalama_map_widget_tools_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_tools['copy_code_title'] >
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_button_copy__text_shm_hitalama_map_widget_tools_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_tools['copy_code'] >
		,
		ReturnType< $mol_button_copy['text'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_widget_tools_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_tools_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_tools_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_tools['z_inc'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_widget_tools_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_tools_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_tools_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_tools['z_dec'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_widget_tools_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_tools_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_tools_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_tools['code_widget_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_widget_tools_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_tools_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_tools_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_tools['preview_reload'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_check_icon__hint_shm_hitalama_map_widget_tools_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__Icon_shm_hitalama_map_widget_tools_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_tools['Settings_widget_enabled_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__checked_shm_hitalama_map_widget_tools_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_tools['settings_widget_enabled'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_list__sub_shm_hitalama_map_widget_tools_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	type $mol_scroll__sub_shm_hitalama_map_widget_tools_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $mol_pick__hint_shm_hitalama_map_widget_tools_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__trigger_content_shm_hitalama_map_widget_tools_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_hitalama_map_widget_tools_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_tools['settings_bubble_content'] >
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_tools_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_tools_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_tools['auto_height'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_icon__Icon_shm_hitalama_map_widget_tools_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_tools['Lock_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__checked_shm_hitalama_map_widget_tools_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_tools['locked'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_link_iconed__sub_shm_hitalama_map_widget_tools_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link_iconed['sub'] >
	>
	type $mol_link_iconed__uri_shm_hitalama_map_widget_tools_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_tools['fullscreen_uri'] >
		,
		ReturnType< $mol_link_iconed['uri'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_widget_tools_30 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_tools_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_tools_32 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_tools['delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $shm_hitalama_map_widget_tools extends $mol_view {
		settings_widget_enabled( next?: ReturnType< ReturnType< $shm_hitalama_map_widget_tools['widget'] >['settings_widget_enabled'] > ): ReturnType< ReturnType< $shm_hitalama_map_widget_tools['widget'] >['settings_widget_enabled'] >
		copy_code_title( ): string
		copy_code( ): string
		Copy_code( ): $mol_button_copy
		Up_icon( ): $mol_icon_arrow_up
		z_inc( next?: any ): any
		Up( ): $mol_button_minor
		Down_icon( ): $mol_icon_arrow_down
		z_dec( next?: any ): any
		Down( ): $mol_button_minor
		Code_widget_icon( ): $mol_icon_code_braces
		code_widget_open( next?: any ): any
		Code_widget( ): $mol_button_minor
		code_widget_tool_visible( ): readonly(any)[]
		Preview_reload_icon( ): $mol_icon_refresh
		preview_reload( next?: any ): any
		Preview_reload( ): $mol_button_minor
		preview_reload_visible( ): readonly(any)[]
		Settings_widget_enabled_icon( ): $mol_icon_cog_outline
		Settings_widget_enabled( ): $mol_check_icon
		settings_check_visible( ): readonly(any)[]
		Settings_trigger_icon( ): $mol_icon_dots_vertical
		settings_content( ): readonly(any)[]
		Settings_content( ): $mol_list
		Settings_scroll( ): $mol_scroll
		settings_bubble_content( ): readonly(any)[]
		Settings_pop( ): $mol_pick
		settings_tool_visible( ): readonly(any)[]
		tools_custom( ): readonly(any)[]
		auto_height( next?: boolean ): boolean
		Auto_height( ): $mol_check_box
		Lock_icon( ): $mol_icon_lock
		locked( next?: boolean ): boolean
		Lock( ): $mol_check_icon
		Fullscreen_icon( ): $mol_icon_arrow_expand_all
		fullscreen_uri( ): string
		Fullscreen( ): $mol_link_iconed
		Delete_icon( ): $mol_icon_trash_can
		delete( next?: any ): any
		Delete( ): $mol_button_minor
		widget( ): $shm_hitalama_map_widget
		Map_page( ): $shm_hitalama_map_page
		copy_code_template( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=tools.view.tree.d.ts.map